import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: {
    branches: [],
    id: null,
    organization_id: null,
    name: null,
    address: null,
    phone: null,
  },
};

const branch = createSlice({
  name: "branch",
  initialState,
  reducers: {
    updateBranches: (state, data) => {
      return {
        value: {
          branches: data.payload.branches,
          id: state.value.id,
          name: state.value.name,
          organization_id: state.value.organization_id,
          address: state.value.address,
          phone: state.value.phone,
        },
      };
    },
    updateActiveBranch: (state, data) => {
      return {
        value: {
          branches: state.value.branches,
          id: data.payload?.id || null,
          name: data.payload?.name || null,
          organization_id: data.payload?.organization_id || null,
          address: data.payload?.address || null,
          phone: data.payload?.phone || null,
        },
      };
    },
    clearBranches: () => {
      return {
        ...initialState,
      };
    },
  },
});

export const { updateBranches, updateActiveBranch, clearBranches } =
  branch.actions;

export default branch.reducer;
